// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
/// Настройки комиссии, для конкретного инструмента, группы или дефолтового
var _a;
import { commisionSplitter } from '@shared/utils/Commission/CommisionSplitter';
import { CommissionOperationType, CommissionTypes, FeeStringVariable } from '@shared/utils/Commission/CommissionEnums';
import { CommissionDefaultAsset } from '@shared/utils/Enums/Constants';
import { KEY_CARE_ORDER, KEY_CUSTODIAL_FEE, KEY_FILLPERLOT, KEY_OPTION_EXERCISE, KEY_ORDER_PER_LOT_WITH_FIXED_PART, KEY_ORDER_VOLUME, KEY_ORDERPERLOT, KEY_PERFILL, KEY_PERORDERVOLUME, KEY_PERPHONETRANSACTION, KEY_PERTRANSACTION, KEY_PERVOLUME, KEY_SHORT_COMMISSION_INFO, KEY_SHORT_POSITION_INTEREST, KEY_SWAP_BUY, KEY_SWAP_SELL, KEY_TOTAL_FEE, KEY_VAT, KEY_VOLUME_WITH_MIN_PD, KEY_FILL_FACE_VALUE } from '@shared/utils/Trading/FeeTextConstants';
import { Resources } from '@shared/localizations/Resources';
import { PriceFormatter } from '@shared/utils/Instruments/PriceFormatter';
import { InstrumentTypes } from '@shared/utils/Instruments/InstrumentTypes';
export class CommissionItem {
    constructor(data) {
        this.Entry = [];
        if (data) {
            this.Entry.push(data);
        }
    }
    get AssetID() {
        if (this.Entry.length > 0) {
            return this.Entry[0].AssetID;
        }
        // if (addLiquidityRebate != null)
        //     return addLiquidityRebate.AssetID;
        // if (removeLiquidityRebate != null)
        //     return removeLiquidityRebate.AssetID;
        return CommissionDefaultAsset.INSTRUMENT_BASE_CCY;
    }
    get Currency() {
        if (this.Entry.length > 0) {
            return this.Entry[0].Currency;
        }
        return '';
    }
    get ShortCommissionInfo() {
        if (this.Entry.length > 0) {
            return this.Entry[0].ShortCommissionInfo;
        }
        return '';
    }
    get CareOrderInfo() {
        for (const entryItem of this.Entry) {
            if (entryItem.IsCareOrder) {
                return true;
            }
        }
        return false;
    }
    GetCommission(params) {
        let result = 0;
        for (const revenueItem of this.Entry) {
            if (!params.AccountOperationType || revenueItem.Type === params.AccountOperationType) {
                result += revenueItem.GetCommission(params);
            }
        }
        return result;
    }
    Add(revenueCommissionEntryItem) {
        const item = revenueCommissionEntryItem;
        // if (item.Type == 31)
        //     addLiquidityRebate = item;
        // else if (item.Type == 32)
        //     removeLiquidityRebate = item;
        // else
        this.Entry.push(item);
    }
    AddFeeItems(itemsForTable, planID, instrument) {
        if (this.ShortCommissionInfo) {
            itemsForTable.push(KEY_SHORT_COMMISSION_INFO);
            return; // <-коммент в #100313
        }
        if (this.CareOrderInfo) {
            itemsForTable.push(KEY_CARE_ORDER);
        }
        const _feeTypesInShowOrder = [
            _a.CommissionTypesKeySuffix[CommissionTypes.PerLot],
            _a.CommissionTypesKeySuffix[CommissionTypes.OrderPerLot],
            _a.CommissionTypesKeySuffix[CommissionTypes.OrderPerLotWithFixedPart],
            _a.CommissionTypesKeySuffix[CommissionTypes.PerVolume],
            _a.CommissionTypesKeySuffix[CommissionTypes.PerOrderVolume],
            _a.CommissionTypesKeySuffix[CommissionTypes.VolumeWithMinPD],
            _a.CommissionTypesKeySuffix[CommissionTypes.PerFill],
            _a.CommissionTypesKeySuffix[CommissionTypes.PerTransaction],
            _a.CommissionTypesKeySuffix[CommissionTypes.PerPhoneTransaction],
            _a.CommissionTypesKeySuffix[CommissionTypes.OptionExercise],
            _a.CommissionTypesKeySuffix[CommissionTypes.VAT],
            _a.CommissionTypesKeySuffix[CommissionTypes.FillFaceValue]
        ];
        for (let i = 0; i < _feeTypesInShowOrder.length; i++) {
            const key = _feeTypesInShowOrder[i];
            const commissionType = CommissionTypes[key];
            if (this.ContainsCommission(commissionType) && this.IsVisibleComissionType(commissionType, instrument)) {
                const showFormat = this.GetShowFormat(commissionType);
                const localKey = 'InstrumentDetailsPanel.' + key;
                switch (commissionType) {
                    case CommissionTypes.PerLot:
                    case CommissionTypes.OrderPerLot:
                    case CommissionTypes.PerVolume:
                    case CommissionTypes.PerOrderVolume:
                    case CommissionTypes.VolumeWithMinPD:
                    case CommissionTypes.OptionExercise:
                    case CommissionTypes.FillFaceValue:
                        if (!this.IsDifficult(commissionType)) {
                            this.AddToTableNotDifficult(itemsForTable, commissionType, showFormat, localKey);
                        }
                        else {
                            // сложный кейс
                            this.AddToTableDifficult(itemsForTable, commissionType, showFormat.containsShort, localKey);
                        }
                        break;
                    case CommissionTypes.PerFill:
                    case CommissionTypes.PerTransaction:
                    case CommissionTypes.PerPhoneTransaction:
                        this.AddToTable(itemsForTable, commissionType, localKey, CommissionOperationType.ALL);
                        break;
                    case CommissionTypes.VAT:
                        itemsForTable.push(localKey);
                        break;
                    case CommissionTypes.OrderPerLotWithFixedPart:
                        this.AddEveryEntryToTable(itemsForTable, localKey, commissionType, CommissionOperationType.ALL, planID);
                }
            }
        }
    }
    ContainsCommission(type) {
        const items = this.Entry;
        if (!(items === null || items === void 0 ? void 0 : items.length))
            return false;
        for (let i = 0; i < items.length; i++) {
            if (items[i].ContainsCommission(type)) {
                return true;
            }
        }
        return false;
    }
    IsVisibleComissionType(type, instrument) {
        switch (type) {
            case CommissionTypes.FillFaceValue:
                return !isNullOrUndefined(instrument) && instrument.InstrType === InstrumentTypes.FIXED_INCOME;
            default:
                return true;
        }
    }
    GetShowFormat(type) {
        const isSingleField = !this.Entry.some((x) => x.CommissionItems.some((y) => y.Type === type && !y.GetShowFormat().isSingleField));
        const ShowOpenClose = this.Entry.some((x) => x.CommissionItems.some((y) => y.Type === type && y.GetShowFormat().isShowOpenClose));
        const ContainsShort = this.Entry.some((x) => x.CommissionItems.some((y) => y.Type === type && y.ContainsShort()));
        return {
            isSingleField,
            showOpenClose: ShowOpenClose,
            containsShort: ContainsShort
        };
    }
    IsDifficult(commissionType) {
        return this.Entry.some((x) => x.CommissionItems.some((y) => y.Type === commissionType && y.CommissionValueItems.some((m) => m.IsBuySellShort)) &&
            this.Entry.some((x) => x.CommissionItems.some((y) => y.Type === commissionType && y.CommissionValueItems.some((m) => m.IsOpenOrClose))));
    }
    IsSingleField(type) {
        for (let i = 0; i < this.Entry.length; i++) {
            if (!this.Entry[i].IsSingleField(type)) {
                return false;
            }
        }
        return true;
    }
    ShowOpenClose(type) {
        for (let i = 0; i < this.Entry.length; i++) {
            if (this.Entry[i].ShowOpenClose(type)) {
                return true;
            }
        }
        return this.Entry.some((x) => x.CommissionItems.some((y) => y.Type === type && y.CommissionValueItems.some((m) => m.IsBuySellShort)));
    }
    ContainsShort(type) {
        for (let i = 0; i < this.Entry.length; i++) {
            if (this.Entry[i].ContainsShort(type)) {
                return true;
            }
        }
        return false;
    }
    AddToTableDifficult(itemsForTable, type, ContainsShort, key) {
        this.AddToTable(itemsForTable, type, key, CommissionOperationType.OPENBUY);
        this.AddToTable(itemsForTable, type, key, CommissionOperationType.OPENSELL);
        if (ContainsShort) {
            this.AddToTable(itemsForTable, type, key, CommissionOperationType.OPENSHORT);
        }
        this.AddToTable(itemsForTable, type, key, CommissionOperationType.CLOSEBUY);
        this.AddToTable(itemsForTable, type, key, CommissionOperationType.CLOSESELL);
    }
    AddToTableNotDifficult(itemsForTable, type, showformat, key) {
        if (showformat.isSingleField) {
            this.AddToTable(itemsForTable, type, key, CommissionOperationType.ALL);
            return;
        }
        if (!showformat.showOpenClose) {
            this.AddToTable(itemsForTable, type, key, CommissionOperationType.BUY);
            this.AddToTable(itemsForTable, type, key, CommissionOperationType.SELL);
        }
        else {
            this.AddToTable(itemsForTable, type, key, CommissionOperationType.OPEN);
            this.AddToTable(itemsForTable, type, key, CommissionOperationType.CLOSE);
        }
        if (showformat.containsShort) {
            // short - #37630 - отсутсвует для Per order volume fee
            this.AddToTable(itemsForTable, type, key, CommissionOperationType.SHORT);
        }
    }
    AddToTable(itemsForTable, type, key, operType) {
        const sP = commisionSplitter;
        const ids = this.LotsListForType(type, operType);
        for (let i = 0; i < ids.length; i++) {
            itemsForTable.push(key + sP + operType + sP + ids[i] + sP + (i + 1 < ids.length ? ids[i + 1] : -1));
        }
    }
    AddEveryEntryToTable(itemsForTable, key, type, operationType, planID) {
        const sP = commisionSplitter;
        this.Entry.forEach((entry) => {
            entry.CommissionItems.filter((item) => item.Type === type).forEach((item) => {
                var _b, _c;
                /* Whole this method is special only for OrderPerLotWithFixedPart! ~ comment in #127202 */
                const range = (_c = (_b = item.CommissionValueItems[0]) === null || _b === void 0 ? void 0 : _b.MinValue) !== null && _c !== void 0 ? _c : 0;
                itemsForTable.push(`${key}${sP}${operationType}${sP}0${sP}${range}${sP}${entry.Type}${sP}${planID}`);
                itemsForTable.push(`${key}${sP}${operationType}${sP}${range}${sP}-1${sP}${entry.Type}${sP}${planID}`);
            });
        });
    }
    LotsListForType(commissionType, operationType) {
        let allLots = []; // для всех всегда есть диапазон который начинается в 0
        if (
        // #38989 сложный кейс
        operationType === CommissionOperationType.OPENBUY ||
            operationType === CommissionOperationType.OPENSELL ||
            operationType === CommissionOperationType.OPENSHORT ||
            operationType === CommissionOperationType.CLOSEBUY ||
            operationType === CommissionOperationType.CLOSESELL) {
            const operType = this.GetComissionOperationTypes(operationType);
            allLots = this.GetLotsListForType(commissionType, operType.type1);
            const tmpLots = this.GetLotsListForType(commissionType, operType.type2);
            for (let i = 0; i < tmpLots.length; i++) {
                const lot = tmpLots[i];
                if (!allLots.includes(lot)) {
                    allLots.push(lot);
                }
            }
        }
        else {
            // простой кейс
            allLots = this.GetLotsListForType(commissionType, operationType);
        }
        allLots.sort(function (a, b) {
            return a - b;
        });
        return allLots;
    }
    GetComissionOperationTypes(commissionOpearationType) {
        switch (commissionOpearationType) {
            case CommissionOperationType.OPENBUY:
                return { type1: CommissionOperationType.OPEN, type2: CommissionOperationType.BUY };
            case CommissionOperationType.OPENSELL:
                return { type1: CommissionOperationType.OPEN, type2: CommissionOperationType.SELL };
            case CommissionOperationType.OPENSHORT:
                return { type1: CommissionOperationType.OPEN, type2: CommissionOperationType.SHORT };
            case CommissionOperationType.CLOSEBUY:
                return { type1: CommissionOperationType.CLOSE, type2: CommissionOperationType.BUY };
            default:
                return { type1: CommissionOperationType.CLOSE, type2: CommissionOperationType.SELL };
        }
    }
    GetLotsListForType(commisionType, commissionOperationType) {
        const allLots = [];
        this.Entry.forEach((x) => {
            x.GetLotsListForType(allLots, commisionType, commissionOperationType);
        });
        return allLots;
    }
    GetCommissionDataValue(feeCurrency, key) {
        const items = this.Entry;
        if ((items === null || items === void 0 ? void 0 : items.length) === 0)
            return null;
        if (key.includes(KEY_FILLPERLOT)) {
            return this.getCommissionDataValue(feeCurrency, key, CommissionTypes.PerLot);
        }
        if (key.includes(KEY_ORDER_PER_LOT_WITH_FIXED_PART)) {
            const isInclusive = key.split(commisionSplitter).at(-3) !== '-1';
            return this.getCommissionDataValue(feeCurrency, key, CommissionTypes.OrderPerLotWithFixedPart, isInclusive, isInclusive);
        }
        if (key.includes(KEY_ORDERPERLOT)) {
            return this.getCommissionDataValue(feeCurrency, key, CommissionTypes.OrderPerLot);
        }
        if (key.includes(KEY_PERFILL)) {
            return this.getCommissionDataValue(feeCurrency, key, CommissionTypes.PerFill);
        }
        if (key.includes(KEY_PERVOLUME)) {
            return this.getCommissionDataValue(feeCurrency, key, CommissionTypes.PerVolume);
        }
        if (key.includes(KEY_PERORDERVOLUME)) {
            return this.getCommissionDataValue(feeCurrency, key, CommissionTypes.PerOrderVolume);
        }
        if (key.includes(KEY_PERTRANSACTION)) {
            return this.getCommissionDataValue(feeCurrency, key, CommissionTypes.PerTransaction);
        }
        if (key.includes(KEY_PERPHONETRANSACTION)) {
            return this.getCommissionDataValue(feeCurrency, key, CommissionTypes.PerPhoneTransaction);
        }
        if (key.includes(KEY_VAT)) {
            return this.GetCommissionStringFormat(feeCurrency, CommissionTypes.VAT, CommissionOperationType.ALL, 0);
        }
        if (key.includes(KEY_VOLUME_WITH_MIN_PD)) {
            return this.GetCommissionStringFormat(feeCurrency, CommissionTypes.VolumeWithMinPD, CommissionOperationType.ALL, 0);
        }
        if (key.includes(KEY_OPTION_EXERCISE)) {
            return this.getCommissionDataValue(feeCurrency, key, CommissionTypes.OptionExercise);
        }
        if (key.includes(KEY_SHORT_COMMISSION_INFO)) {
            return this.ShortCommissionInfo;
        }
        if (key.includes(KEY_CARE_ORDER)) {
            return this.GetCommissionStringFormat(feeCurrency, CommissionTypes.ShortCommissionInfo, CommissionOperationType.ALL, 0);
        }
        if (key.includes(KEY_FILL_FACE_VALUE)) {
            return this.getCommissionDataValue(feeCurrency, key, CommissionTypes.FillFaceValue);
        }
        return null;
    }
    getCommissionDataValue(feeCurrency, key, type, isLowerBoundInclusive = true, isUpperBoundInclusive = false) {
        const commisionKey = key.split(commisionSplitter);
        const operationType = parseFloat(commisionKey[1]);
        const fromLots = parseFloat(commisionKey[2]);
        const lotsTo = parseFloat(commisionKey[3]);
        const feeNameID = parseInt(commisionKey[4]);
        return _a.GetFeeString(fromLots, lotsTo, this.GetCommissionStringFormat(feeCurrency, type, operationType, fromLots, null, feeNameID), isLowerBoundInclusive, isUpperBoundInclusive, feeNameID);
    }
    GetCommissionValue(commissionType, commissionOperationType, fromLots, isRebates) {
        isRebates = isRebates || false;
        const param = {
            CommissionType: commissionType,
            OperationType: commissionOperationType,
            Entry: this.Entry,
            Lots: fromLots,
            IgnoreMinMaxCorrection: true
        };
        return _a.GetCommissionForType(param) * (isRebates ? -1 : 1);
    }
    /// string representation of commision in selected Currency or %
    GetCommissionStringFormat(feeCurrency, commissionType, commissionOperationType, fromLots, isRebates, feeNameID) {
        const value = this.GetCommissionValue(commissionType, commissionOperationType, fromLots, isRebates);
        if (!value && !this.ContainsCommission(commissionType)) {
            return null;
        }
        if (commissionType === CommissionTypes.OrderPerLotWithFixedPart) {
            return this.GetOrderPerLotWithFixedPartFormattedValue(feeCurrency, fromLots, feeNameID);
        }
        return _a.FormatCommissionValue(value, feeCurrency, commissionType);
    }
    GetOrderPerLotWithFixedPartFormattedValue(feeCurrency, fromLots, feeNameID) {
        var _b, _c, _d;
        const entry = (_b = this.Entry) === null || _b === void 0 ? void 0 : _b.find((e) => e.Type === feeNameID);
        const item = (_c = entry === null || entry === void 0 ? void 0 : entry.CommissionItems) === null || _c === void 0 ? void 0 : _c.find((i) => i.Type === CommissionTypes.OrderPerLotWithFixedPart);
        const valueItem = (_d = item === null || item === void 0 ? void 0 : item.CommissionValueItems) === null || _d === void 0 ? void 0 : _d[0];
        if (!valueItem)
            return null;
        const { Value, MaxValue } = valueItem;
        const formattedValue = PriceFormatter.formatNumberWithPrecision(Value);
        const formattedMaxValue = PriceFormatter.formatNumberWithPrecision(MaxValue);
        return fromLots
            ? `${formattedValue} ${feeCurrency} + ${formattedMaxValue} ${feeCurrency} ${Resources.getResource('InstrumentDetailsPanel.perLot')}`
            : `${formattedValue} ${feeCurrency}`;
    }
    GetCommissionInfo() {
        return this.ShortCommissionInfo;
    }
    static GetFeeString(lotsFrom, lotsTo, value, allowLimit, allowHighLimit, feeVar = FeeStringVariable.Amount) {
        if (lotsFrom === 0 && lotsTo === -1) {
            return value;
        }
        const localizeKey = Resources.getResource(feeVar === FeeStringVariable.Price ? 'InstrumentDetailsPanel.Price' : 'InstrumentDetailsPanel.Amount');
        const leftCompare = allowLimit ? ' <= ' : ' < ';
        const rightCompare = allowHighLimit ? ' <= ' : ' < ';
        const toValue = lotsTo === -1 ? '\u221e' : PriceFormatter.formatNumberWithPrecision(lotsTo);
        const lotsFromS = PriceFormatter.formatNumberWithPrecision(lotsFrom);
        return `${lotsFromS}${leftCompare}${localizeKey}${rightCompare}${toValue}${commisionSplitter}${value}`;
    }
    static GetCommissionOperationTypes(operationType) {
        switch (operationType) {
            case CommissionOperationType.OPENBUY:
                return [CommissionOperationType.OPEN, CommissionOperationType.BUY];
            case CommissionOperationType.OPENSELL:
                return [CommissionOperationType.OPEN, CommissionOperationType.SELL];
            case CommissionOperationType.OPENSHORT:
                return [CommissionOperationType.OPEN, CommissionOperationType.SHORT];
            case CommissionOperationType.CLOSEBUY:
                return [CommissionOperationType.CLOSE, CommissionOperationType.BUY];
            default:
                return [CommissionOperationType.CLOSE, CommissionOperationType.SELL];
        }
    }
    static GetCommissionForType(param) {
        if (param.CommissionType === CommissionTypes.VAT) {
            return _a.GetVatCommission(param);
        }
        if (param.CommissionType === CommissionTypes.OrderPerLotWithFixedPart) {
            return _a.GetVatCommission(param);
        }
        const operationType = param.OperationType;
        if (operationType === CommissionOperationType.OPENBUY ||
            operationType === CommissionOperationType.OPENSELL ||
            operationType === CommissionOperationType.OPENSHORT ||
            operationType === CommissionOperationType.CLOSEBUY ||
            operationType === CommissionOperationType.CLOSESELL) {
            const operType = _a.GetCommissionOperationTypes(operationType);
            let value = 0;
            param.OperationType = operType[0];
            value += _a.CalculateCommissionForType(param);
            param.IsNotIgnoreAll = false;
            param.OperationType = operType[1];
            value += _a.CalculateCommissionForType(param); // не учитываем операции All, ранее они уже были посчитаны
            return value;
        }
        return _a.CalculateCommissionForType(param);
    }
    static GetVatCommission(param) {
        // foreach(var entry in Entry.Where(x => x.UseInVAT))
        // foreach(var item in entry.CommissionItems.Where(y => y.Type == CommissionTypes.VAT))
        // return item.CommissionValueItems[0].Value;
        return _a.CalculateCommissionForType(param);
    }
    static CalculateCommissionForType(param) {
        let value = 0;
        for (let i = 0; i < param.Entry.length; i++) {
            const entry = param.Entry[i];
            // Для total и vat расчета проверяем флаг UseInVat
            if ((!param.IgnoreUseInVat && !entry.UseInVAT) || entry.IsEmpty) {
                continue;
            }
            value += entry.GetCommission(param);
        }
        return value;
    }
    static GetCommissionCurrency(account, instrument) {
        const item = account.CommissionPlan.GetCommissionItem(instrument);
        if (isNullOrUndefined(item))
            return null;
        const dCache = instrument.DataCache;
        if (isNullOrUndefined(dCache)) {
            return item.Currency;
        }
        if (item.AssetID >= 0) {
            const asset = dCache.GetAssetById(item.AssetID);
            if (asset != null) {
                return asset.Name;
            }
        }
        if (item.AssetID === CommissionDefaultAsset.INSTRUMENT_BASE_CCY) {
            return instrument.Exp1;
        }
        if (item.AssetID === CommissionDefaultAsset.INSTRUMENT_QUOTING_CCY) {
            return instrument.Exp2;
        }
        return item.Currency;
    }
    static GetCommissionTypeByKey(key) {
        switch (key) {
            case KEY_FILLPERLOT:
                return CommissionTypes.PerLot;
            case KEY_ORDERPERLOT:
                return CommissionTypes.OrderPerLot;
            case KEY_PERVOLUME:
                return CommissionTypes.PerVolume;
            case KEY_VOLUME_WITH_MIN_PD:
                return CommissionTypes.VolumeWithMinPD;
            case KEY_PERFILL:
                return CommissionTypes.PerFill;
            case KEY_PERTRANSACTION:
                return CommissionTypes.PerTransaction;
            case KEY_PERPHONETRANSACTION:
                return CommissionTypes.PerPhoneTransaction;
            case KEY_VAT:
                return CommissionTypes.VAT;
            case KEY_ORDER_VOLUME:
            case KEY_PERORDERVOLUME:
                return CommissionTypes.PerOrderVolume;
            case KEY_CARE_ORDER:
                return CommissionTypes.CareOrder;
            case KEY_ORDER_PER_LOT_WITH_FIXED_PART:
                return CommissionTypes.OrderPerLotWithFixedPart;
            case KEY_TOTAL_FEE:
                return CommissionTypes.TotalFee;
            case KEY_OPTION_EXERCISE:
                return CommissionTypes.OptionExercise;
            case KEY_SWAP_BUY:
                return CommissionTypes.SwapBuy;
            case KEY_SWAP_SELL:
                return CommissionTypes.SwapSell;
            case KEY_SHORT_COMMISSION_INFO:
                return CommissionTypes.ShortCommissionInfo;
            case KEY_CUSTODIAL_FEE:
                return CommissionTypes.CustodialFee;
            case KEY_SHORT_POSITION_INTEREST:
                return CommissionTypes.ShortPositionInterest;
            case KEY_FILL_FACE_VALUE:
                return CommissionTypes.FillFaceValue;
            default:
                return null;
        }
    }
    static FormatCommissionValue(value, feeCurrency, commissionType, key) {
        const formattedValue = PriceFormatter.formatNumberWithPrecision(value);
        let result;
        switch (commissionType) {
            case CommissionTypes.VolumeWithMinPD:
            case CommissionTypes.VAT:
            case CommissionTypes.PerVolume:
            case CommissionTypes.PerOrderVolume:
            case CommissionTypes.FillFaceValue:
                result = formattedValue + ' %';
                break;
            default:
                result = formattedValue + ' ' + feeCurrency;
                break;
        }
        if (key) {
            const lotsFrom = parseFloat(key.split(commisionSplitter)[2]);
            const lotsTo = parseFloat(key.split(commisionSplitter)[3]);
            const allowLimit = true; // Assuming default behavior for limits
            const allowHighLimit = false; // Assuming default behavior for high limits
            return _a.GetFeeString(lotsFrom, lotsTo, result, allowLimit, allowHighLimit);
        }
        return result;
    }
}
_a = CommissionItem;
CommissionItem.CommissionTypesKeySuffix = Object.fromEntries(Object.entries(CommissionTypes).map(([k, v]) => [v, k]));
CommissionItem.NumericCommissionTypes = Object.keys(_a.CommissionTypesKeySuffix).map((key) => Number(key));
CommissionItem.OperationTypeSuffix = Object.keys(CommissionOperationType).filter((key) => isNaN(Number(key))); /* Filter out numeric keys */
